export default function Estudos() {
  return <h2>Estudos</h2>;
}
